// extracted by mini-css-extract-plugin
module.exports = {"vertical":"ButtonSpacer__vertical___2vtnI"};